import React from 'react';

import Button from "components/CustomButtons/Button.jsx";
import { Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress } from '@material-ui/core';
import ReactSelect from '../../../../components/Select/ReactSelect';
import ProductImage from '../../../../components/Image/ProductImage';
import Api from '../../../../api/Api.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { connect } from 'react-redux';
import CustomerEndpoints from '../../../../api/CustomerEndpoints';

class AddProductDialog extends React.Component {

    state = {
        loading: false,
        selectedProduct: { label: 'None', value: null }
    }

    submit() {
        this.setState({ loading: true }, () =>
            Api.get(CustomerEndpoints.addProduct, { customer_id: this.props.customer_id, product_id: this.state.selectedProduct.value })
                .then(({ data }) => {
                    this.props.onClose();
                    this.props.refresh();
                    this.setState({ loading: false, selectedProduct: { label: 'None', value: null } })
                })
                .catch((e) => this.setState({ loading: false }, () => console.error(e)))
        );
    }

    render() {
        return (
            <Dialog
                open={this.props.isOpen}
                onClose={this.props.onClose}
                fullWidth
                maxWidth="sm"
                aria-labelledby="form-dialog-title"
                PaperProps={{ style: { overflow: 'visible' } }}
            >
                <DialogTitle id="form-dialog-title">Add Product to Customer</DialogTitle>
                <DialogContent style={{ overflow: 'visible' }}>
                    <ReactSelect
                        options={
                            [
                                { label: 'None', value: null }
                            ]
                                .concat(
                                    this.props.products
                                        .filter(product => !this.props.existing_products.some(x => x.id === product.id))
                                        .map(product => ({ avatar: <ProductImage {...product} />, label: product.name, value: product.id }))
                                )
                        }
                        onChange={(value) => this.setState({ selectedProduct: value })}
                        placeholder="No Product Selected"
                        value={this.state.selectedProduct}
                        isSearchable
                        isLoading={this.state.loading}
                        isDisabled={this.state.loading}
                    />
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginRight: 'auto' }} round onClick={this.props.onClose} color="rose" simple>
                        Cancel
                    </Button>


                    {
                        this.state.loading ?
                            <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                            :
                            <Button
                                onClick={() => this.submit()}
                                color="rose"
                                round
                                disabled={this.state.selectedProduct.value === null}
                            >
                                Add Product
                                &nbsp;&nbsp;
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = (state) => {
    return ({
        products: state.products.list
    });
}

export default connect(mapStateToProps)(AddProductDialog);